export default __webpack_public_path__ + "static/media/sample-bg.cab0b6ed.jpg";